var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad"},[_c('p',[_vm._v("【PR】")]),_c('Adsense',{attrs:{"data-ad-client":"ca-pub-8143206471999291","data-ad-slot":"4919886080"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }